import { render, staticRenderFns } from "./ApiKeySecurityRestrictionsIpItems.vue?vue&type=template&id=6c702225&scoped=true&"
import script from "./ApiKeySecurityRestrictionsIpItems.vue?vue&type=script&lang=js&"
export * from "./ApiKeySecurityRestrictionsIpItems.vue?vue&type=script&lang=js&"
import style0 from "./ApiKeySecurityRestrictionsIpItems.vue?vue&type=style&index=0&id=6c702225&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c702225",
  null
  
)

export default component.exports